/* eslint-disable react/jsx-no-target-blank */
import styled from 'styled-components'
import { Box } from '../ui/Layout.js'

const ShareContainer = styled(Box)`
  width: 0px;
  height: 20px;
  position: absolute;
  bottom: 8px;
  ${(props) => {
    if (props.noArrows) {
      return 'right: 8px;'
    }
    if (props.widgetArrowPosition === 'INSIDE') {
      return 'right: 8px;'
    }
    if (props.widgetArrowPosition === 'CENTER_BELOW' || props.widgetArrowPosition === 'BELOW') {
      return 'right: 8px;'
    }
    if (props.widgetArrowPosition === 'OVERLAP') {
      return 'right: 28px;'
    }
    if (props.widgetArrowPosition === 'OUTSIDE') {
      return 'right: 64px;'
    }
  }}
  display: flex;
  align-items: center;

  &:hover {
    .share-button {
      opacity: 1;
      transform: translateX(0);
      pointer-events: auto;
    }

    .icon-wrapper {
      transform: translateX(-65px);
    }
  }
`

const ShareButton = styled.button`
  position: absolute;
  bottom: 0px;
  right: 0px;
  background: rgba(255, 255, 255, 0.5) !important;
  border: none !important;
  border-radius: 4px !important;
  padding: 4px 8px !important;
  cursor: pointer;
  opacity: 0;
  transform: translateX(20px);
  transition: all 0.3s ease;
  white-space: nowrap !important;
  pointer-events: none;
  font-weight: 600 !important;
  font-size: 13px !important;
  font-family: ${(props) => (props.fontFamily ? props.fontFamily.replace(';') : 'inherit')} !important;
  background-color: ${(props) => props.backgroundColor || '#333333'} !important;
  color: white !important;
  user-select: none;
`

const IconWrapper = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
  height: 20px;
  margin-bottom: 2px;
  transform: translateX(0) rotate(0deg);
  transition: transform 0.3s ease;

  ${ShareContainer}:hover & {
    path {
      transition: fill-opacity 0.3s ease;
      fill-opacity: 1 !important;
    }
    transform: translateX(-65px) rotate(-180deg);
  }
`

const InlineShare = ({ campaign, noArrows }) => {
  if (!campaign.widgetShareButton) return null
  return (
    <a target="_blank" href={`https://getclipara.com/share/${campaign.id}?showShare=true&utm_source=inline-carousel-share`}>
      <ShareContainer noArrows={noArrows} widgetArrowPosition={campaign.widgetArrowPosition}>
        <ShareButton className="share-button" backgroundColor={campaign.playButtonColor} fontFamily={campaign.widgetFontFamily}>
          Share
        </ShareButton>
        <IconWrapper className="icon-wrapper">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M20 6.74528H13.2235V0H6.72941C6.72941 3.72642 3.71765 6.74528 0 6.74528V13.2547H6.72941V20H13.2235C13.2235 16.2736 16.2824 13.2547 20 13.2547V6.74528Z"
              fill="white"
              fillOpacity="0.8"
            />
          </svg>
        </IconWrapper>
      </ShareContainer>
    </a>
  )
}

export default InlineShare
